<div class="profile-page">
  <header class="profile-header">
    <div class="header-toolbar">
      <button class="back-button" (click)="goBack()">
        <i class="fas fa-arrow-left"></i>
      </button>
      <h1 class="page-title">Profile Details</h1>
      <button class="home-btn" (click)="navigateToSavedAddresses()" *ngIf="accType == '2'">
        <i class="fas fa-home"></i>
      </button>
    </div>
  </header>

  <div class="profile-card">
    <div class="profile-header">
      <div class="pic" (click)="uploadUserImage()">
        <div class="loader" *ngIf="isLoading">
          <div class="spinner"></div>
        </div>
        <ng-container *ngIf="!isLoading">
          <div class="empty" *ngIf="userData.img === ''">
            <i class="fas fa-user-circle"></i>
          </div>
          <div class="cover" *ngIf="userData?.img">
            <img [src]="userData?.img" alt="User" class="avatar-img" />
          </div>
        </ng-container>

         <i class="fas fa-camera"></i>
      </div>

      <h2 class="company-name">
          {{ userData?.orgName }}
      </h2>
    </div>
    <!-- <div class="avatar-container" (click)="uploadUserImage()">
        <div class="avatar-wrapper">
        <ng-container *ngIf="isLoading; else avatarLoaded">
            <div class="spinner"></div>
        </ng-container>

        <ng-template #avatarLoaded>
            <img *ngIf="userData?.img; else defaultAvatar" [src]="userData?.img" alt="User" class="avatar-img" />
            <ng-template #defaultAvatar>
            <div class="avatar-default">
                <i class="fas fa-user-circle"></i>
            </div>
            </ng-template>
            <div class="avatar-camera">
            <i class="fas fa-camera"></i>
            </div>
        </ng-template>
        </div>
    </div> -->


    <ul class="profile-list">
      <li class="profile-item">
        <i class="fas fa-user"></i>
        <div>
          <p class="label">Name</p>
          <p class="value">{{ userData?.name }}</p>
        </div>
      </li>
      <li class="profile-item">
        <i class="fas fa-phone-alt"></i>
        <div>
          <p class="label">Mobile No</p>
          <p class="value">+91 {{ userData?.mblno }}</p>
        </div>
      </li>
      <li class="profile-item">
        <i class="fas fa-briefcase"></i>
        <div>
          <p class="label">Account Type</p>
          <p class="value">{{ userData?.accountTypeLabel }}</p>
        </div>
      </li>
    </ul>

    <button
      class="change-password-btn"
      [disabled]="isLoading"
      (click)="navigateToChangePassword()"
    >
      Change Password
    </button>
  </div>

  <div class="author-footer">
   <div class="footer-branding">
    <p class="brand-name" *ngIf="brandName">{{ brandName }}</p>
    <div class="powered-by">
      <span>Powered by</span>
      <img src="assets/aze.png" alt="AzeApp Logo" />
    </div>
  </div>
  </div>
</div>
